export default {
  tenant: 'Tenant',
  tenants: 'Tenants',
  tenantsOf: '{{type}} Tenants',
  'tenant.name': 'Tenant Name',
  'tenant.description': 'Additional information about the tenant or project',
  'tenant.verification': 'KYB Verification Level',
  'tenant.kyb.basic': 'Basic (Email only)',
  'tenant.kyb.standard': 'Standard (Email + Phone)',
  'tenant.kyb.premium': 'Premium (Full Verification)',
  'tenant.list.title': 'Tenant Management',
  'tenant.list.subtitle': 'Manage your application tenants effectively.',
  'tenant.list.search.placeholder': 'Search tenants by name or description',
  'tenant.info': 'Tenant Information',
  'tenant.form.title': 'Tenant Title',
  'tenant.form.description': 'Tenant Description',
  'tenant.form.assignments': 'Assignments',
  'tenant.info.helper':
    'Provide a clear title, concise description, and appropriate type to define the tenant',
  'tenant.api': 'API Settings',
  'tenant.api.helper': 'Configure API settings for the tenant',
  'tenant.api.origins': 'Allowed Origins (CORS)',
  'tenant.api.origins.helper':
    'Full origins allowed to make API requests. Format: http(s)://host[:port] — e.g. https://example.com, http://localhost:5173, https://*.example.com. Leave empty to allow all. Use "*" to allow any origin (not recommended).',
  'tenant.api.origins.wildcard.warning':
    'Warning: "*" allows requests from ANY origin. This disables CORS protection for this tenant — use only for public, non-sensitive data.',
  'tenant.api.origins.invalid':
    'Invalid origin(s): {{values}}. Each entry must be "*" or start with http:// or https:// and contain a host (and optional port).',
  'tenant.api.limit': 'Monthly Request Limit',
  'tenant.api.expiration': 'API Key Expiration Date',
  'tenant.api.active': 'Active Key',
  'tenant.api.active.on': 'Active',
  'tenant.api.active.off': 'Inactive',
  'tenant.api.token.info':
    'Create a fine-grained, {name}-scoped token suitable for personal API use',
  'tenant.api.token.helper': 'The token will expire on the selected date',
  'tenant.api.name.helper':
    'A unique name for this tenant. May be visible to resource owners or users with possession of the token.',
  'tenant.api.subscriptions.available': 'Available Subscriptions',
  'tenant.api.subscriptions.available.placeholder':
    'Select subscriptions available to this tenant',
  'tenant.api.generateKey': 'Generate new API Key',
  'tenant.api.handleKey': 'Manage API Key',
  'tenant.api.keyCreated': 'API Key Successfully Created',
  'tenant.api.keyCopied': 'API key copied to clipboard',
  'tenant.api.keys.title': 'API Keys',
  'tenant.api.keys.delete.confirm':
    'Are you sure you want to delete this API key?',
  'tenant.api.keys.activate.confirm':
    'Are you sure you want to activate this API key?',
  'tenant.api.keys.deactivate.confirm':
    'Are you sure you want to deactivate this API key?',
  'tenant.api.keys.delete.success': 'API key deleted successfully',
  'tenant.api.keys.deactivate.success': 'API key deactivated successfully',
  'tenant.api.keys.noKeys': 'No API keys found',
  'tenant.api.keys.usageCount': 'Usage Count',
  'tenant.api.keys.info.attention': 'Attention!',
  'tenant.api.keys.info.attention.alert':
    'Do not share this key with third parties. If the key is compromised, immediately revoke it in the management panel.',
  'tenant.api.keys.info.attention.helper':
    'Please save this API key. It will not be shown again in the system.',
};
